import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as userActions from '../actions';
import { produceOn } from '../../../../reducers/immer.helper';

export interface UserState {
  user?: any[];
  currentData?: any;
  result?: any;
  isLoading?: boolean;
  actionInProgress?: boolean;
  actionSuccessful?: boolean;
}
export const initialState: UserState = {
  user: [],
  currentData: {},
  result: '',
  isLoading: false,
  actionInProgress: false,
  actionSuccessful: true,
};

const userReducer = createReducer(
  initialState,
  //create user
  produceOn(userActions.createUser, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(userActions.createUserSuccess, (draft, result) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = result.data;
  }),
  produceOn(userActions.createUserFailure, (draft, result) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),
  produceOn(userActions.updateUser, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),

  produceOn(userActions.updateUserSuccess, (draft, result) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = result.data;
  }),

  produceOn(userActions.updateUserFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  produceOn(userActions.getUserById, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),

  produceOn(userActions.getUserByIdSuccess, (draft, result) => {
    draft.user?.push(result.data);
    draft.currentData = result.data;
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),
  
  produceOn(userActions.getUserByIdFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  produceOn(userActions.clearProfileImage, (draft) => {
    if (draft.currentData) {
      draft.currentData.profilePic = null;
    }
  })
);

export function reducer(state: UserState| undefined, action: Action): any {
  return userReducer(state, action);
}


